import { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { tariffRatesApi } from '../../api/tariffRates';

export default function AddMaterialDialog({ open, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    hts_code: '',
    default_unit_cost: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await tariffRatesApi.createMaterial(formData);
      if (response.success) {
        onSuccess();
        setFormData({
          name: '',
          category: '',
          hts_code: '',
          default_unit_cost: ''
        });
      } else {
        alert(response.error || 'Failed to create material');
      }
    } catch (error) {
      console.error('Error creating material:', error);
      alert('Failed to create material');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold">Add Material</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Material Name *
            </label>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g., Steel (Hot-rolled), ABS Plastic"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Category
            </label>
            <Input
              name="category"
              value={formData.category}
              onChange={handleChange}
              placeholder="e.g., Metal, Plastic, Rubber"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              HTS Code
            </label>
            <Input
              name="hts_code"
              value={formData.hts_code}
              onChange={handleChange}
              placeholder="e.g., 7208.51.00"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Default Unit Cost ($/kg)
            </label>
            <Input
              name="default_unit_cost"
              type="number"
              step="0.01"
              min="0"
              value={formData.default_unit_cost}
              onChange={handleChange}
              placeholder="e.g., 1.10"
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-4">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Creating...' : 'Create Material'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
